import React, { useEffect, useState } from "react";
import { X, Star, MessageSquareHeart } from "lucide-react";
import { TelegramButton, TG_REVIEW_URL, TG_SUPPORT_URL } from "./TelegramButton";

// 24h in-app review ask for existing users. Window is server-driven (/api/public/review-window).
const LS_BASE = "ws_review_popup_dismissed";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ReviewPopup = () => {
  const [open, setOpen] = useState(false);
  const [lsKey, setLsKey] = useState(LS_BASE);
  useEffect(() => {
    let t;
    fetch(`${API}/public/review-window`).then((r) => r.json()).then((d) => {
      if (!d.active) return;
      const k = `${LS_BASE}_${d.started_at || ""}`;  // dismissal is per window — Restart re-shows to everyone
      setLsKey(k);
      if (localStorage.getItem(k)) return;
      t = setTimeout(() => setOpen(true), 1400);
    }).catch(() => {});
    return () => clearTimeout(t);
  }, []);
  const close = () => { localStorage.setItem(lsKey, "1"); setOpen(false); };
  if (!open) return null;
  return (
    <div className="ws-launch-overlay" onClick={close} data-testid="review-popup">
      <div className="ws-launch-card ws-review-card" onClick={(e) => e.stopPropagation()}>
        <div className="ws-launch-aurora" aria-hidden />
        <div className="ws-launch-rays" aria-hidden />
        <button className="ws-launch-close" onClick={close} aria-label="Close" data-testid="review-popup-close"><X className="w-4 h-4" /></button>
        <div className="ws-launch-eyebrow ws-review-eyebrow"><MessageSquareHeart className="w-3.5 h-3.5" /> Your voice matters</div>
        <div className="ws-review-stars" aria-hidden>{[0, 1, 2, 3, 4].map((i) => <Star key={i} className="w-6 h-6" style={{ animationDelay: `${i * 120}ms` }} />)}</div>
        <h3 className="ws-launch-title">How's your experience with <span className="ws-brand-name">WSDT</span>?</h3>
        <p className="ws-launch-sub">You're one of the first traders inside the Wealth Secret Data Terminal. Drop a quick review on Telegram — it shapes what we build next.</p>
        <TelegramButton href={TG_REVIEW_URL} label="Drop your review on Telegram" size="lg" className="ws-launch-cta" testid="review-popup-cta" />
        <div className="ws-review-alt">Facing an issue instead? <a href={TG_SUPPORT_URL} target="_blank" rel="noopener noreferrer" data-testid="review-popup-issue">Message us directly</a></div>
        <button onClick={close} className="ws-launch-later" data-testid="review-popup-later">Maybe later</button>
      </div>
    </div>
  );
};

export default ReviewPopup;
